<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      show-save-button
      unit="商品档案"
      edit-title
      id-key="GoodsId"
      :data="data"
      :form-rules="rules"
      :before-save="onBeforeSave"
      :save-func="api.save"
      :get-data-func="api.info"
      form-label-width="110px"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品分类">
              <el-cascader 
                v-model="data.ClassId" 
                :options="classList" 
                :props="{ 
                  value: 'ClassId',
                  label: 'ClassName',
                  children: 'children',
                  checkStrictly: true,
                  emitPath: false
                }"
                placeholder="请选择商品分类"
                filterable
                clearable
                @change="handleClassChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品条码" prop="BarCode">
              <el-input v-model="data.BarCode" placeholder="请输入商品条码(留空默认等于商品编码)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品编码" prop="GoodsCode">
              <el-input v-model="data.GoodsCode" placeholder="请输入商品编码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品名称" prop="GoodsName">
              <el-input v-model="data.GoodsName" placeholder="请输入商品名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="规格型号" prop="Model">
              <el-input v-model="data.Model" placeholder="请输入规格型号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品标签" prop="Tags">
              <el-input v-model="data.Tags" placeholder="请输入商品标签"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品属性">
              <el-checkbox v-model="data.IsSale">销售</el-checkbox>
              <el-checkbox v-model="data.IsPurchase">采购</el-checkbox>
              <el-checkbox v-model="data.IsSelf">自制</el-checkbox>
              <el-checkbox v-model="data.IsConsume">耗材</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品类型" prop="GoodsType">
              <el-select size="mini" v-model="data.GoodsType" style="width: 100%" placeholder="请选择商品类型">
                <el-option label="劳务" :value="1"></el-option>
                <el-option label="实物" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="主计量单位" prop="MainUnitId">
              <unit-select v-model="data.MainUnitId" @change="getUnit"></unit-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <el-form-item label="参考成本" prop="ReferenceCost">
              <el-input v-model="data.ReferenceCost" placeholder="请输入参考成本"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="8">
            <el-form-item>
              <el-checkbox :disabled="!data.MainUnitId" v-model="data.MultiUnit">启用多计量单位</el-checkbox>
              <el-tooltip content="如果采购和销售的计量单位不同，可启用多计量单位" placement="top-start">
                <i style="margin-left: 2px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>-->
          <el-col :span="16" v-if="data.MultiUnit">
            <el-form-item label="选择单位" prop="MultiUnitIds">
              <el-select style="width: 100%" v-model="data.MultiUnitIds" multiple placeholder="请选择单位">
                <template v-for="(i, key) in MultiUnits">
                  <el-option :label="i.UnitName" :value="i.UnitId"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="最低库存" prop="LowStock">
              <el-input v-model="data.LowStock" type="number" placeholder="请输入最低库存"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最高库存" prop="HighStock">
              <el-input v-model="data.HighStock" type="number" placeholder="请输入最高库存"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="安全库存" prop="SafeStock">
              <el-input v-model="data.SafeStock" type="number" placeholder="请输入安全库存"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="默认仓库" prop="WarehouseId">
              <warehouse-select v-model="data.WarehouseId"></warehouse-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="最新进价" prop="NewPrice">
              <el-input v-model="data.NewPrice" type="number" placeholder="请输入最新进价"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="平均成本" prop="AvgCost">
              <el-input v-model="data.AvgCost" type="number" placeholder="请输入平均成本"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="品牌" prop="BrandId">
              <brand-select v-model="data.BrandId"></brand-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产地" prop="Origin">
              <el-input v-model="data.Origin" placeholder="请输入产地"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="税收分类编码" prop="TaxClassCode">
              <el-input v-model="data.TaxClassCode" placeholder="请输入税收分类编码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="默认供应商" prop="GoodsSupplierIds">
              <el-input
                v-model="data.GoodsSupplierNames"
                @click.native="openSupplierDialog"
                placeholder="请选择默认供应商"
              ></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <el-form-item label="输入小数" prop="IsDecimal">
              <el-radio-group v-model="data.IsDecimal">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>单位</el-divider>
        <dialog-list ref="dialogList" :info="data" />
        <dialog-list1 ref="dialogList1" :info="data" />
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <supplier-dialog ref="supplierDialog" in-dialog selectable multiple @select-multiple="setSupplier" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import unitSelect from '@/components/basicinfo/goods/unit/select'
import brandSelect from '@/components/basicinfo/goods/brand/select'
import warehouseSelect from '@/components/basicinfo/basic/warehouse/select'
import supplierDialog from '@/components/purchase/supplier/archives/listDialog'
import dialogList from './dialogList'
import dialogList1 from './dialogList1'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    unitSelect,
    brandSelect,
    warehouseSelect,
    supplierDialog,
    dialogList,
    dialogList1
  },
  data() {
    return {
      api: require('@/api/goods/goods').default,
      supplier_api: require('@/api/goods/goodsSupplier').default,
      m_unit_api: require('@/api/goods/measurementUnit').default,
      unit_api: require('@/api/ba/unit').default,
      classApi: require("@/api/ba/class").default,
      data: {
        GoodsId: 0,
        BarCode: '', //条码
        GoodsCode: '', //编码
        GoodsName: '', //名称
        Model: '', //规格型号
        Tags: '', //标签
        IsSale: false, //属性-销售
        IsPurchase: false, //属性-采购
        IsSelf: false, //属性-自制
        IsConsume: false, //属性-耗材
        GoodsType: 0, //商品类型 - 0:实物，1:劳务
        ReferenceCost: null, //参考成本
        MainUnitId: null, //主计量单位Id
        MultiUnit: false, //多计量
        MultiUnitIds: [],
        LowStock: null, //最低库存
        HighStock: null, //最高库存
        SafeStock: null, //安全库存
        NewPrice: null, //最新进价
        AvgCost: null, //平均成本
        BrandId: null, //品牌Id
        Origin: '', //产地
        TaxClassCode: '', //税收分类编码
        WarehouseId: null, //仓库Id
        Remark: '', //备注
        Status: 1, //状态 - 0:停用 1:正常
        ClassId: 0, //分类Id
        ClassName: '',
        IsDecimal: true,
        GoodsSupplierIds: [],
        GoodsSupplierNames: '',
        MultiUnits: [],
        GoodsSuppliers: []
      },
      classList: [],
      MultiUnits: [],
      rules: {
        // BarCode: [{ required: true, message: "条码不能为空" }],
        GoodsCode: [{ required: true, message: '商品编码不能为空' }],
        GoodsName: [{ required: true, message: '商品名称不能为空' }],
        // Model: [{ required: true, message: "规格型号不能为空" }],
        // Tags: [{ required: true, message: "标签不能为空" }],
        ReferenceCost: [
          // { required: true, message: "参考成本不能为空" },
          { validator: this.$commonJs.validateRules.decimal }
        ],
        MainUnitId: [{ required: true, message: '请选择主计量单位' }],
        MultiUnitIds: [{ required: true, message: '请选择多计量单位' }],
        // BrandId: [{ required: true, message: "请选择品牌" }],
        WarehouseId: [{ required: true, message: '请选择仓库' }]
        // GoodsType: [{ required: true, message: "请选择商品类型" }],
        // GoodsSupplierIds: [{ required: true, message: "请选择默认供应商" }],
      }
    }
  },
  computed: {},
  mounted() {
    this.classApi.list({ ClassType: 6 }).then(res => {
      this.classList = this.$commonJs.toTreeData(res.Data, "ClassId");
    })
  },
  methods: {
    onCreateOpened(data) {},
    onEditOpened(data) {
      this.$refs.dialogList.tableDel = []
      this.$refs.dialogList.getData()
      this.$refs.dialogList1.tableDel = []
      this.$refs.dialogList1.getData()
      this.supplier_api.list({ GoodsId: this.data.GoodsId }).then(res => {
        this.data.GoodsSupplierIds = res.Data.map(x => x.SupplierId)
        this.data.GoodsSupplierNames = res.Data.map(x => x.SupplierName).join('；')
      })
      this.m_unit_api.list({ GoodsId: this.data.GoodsId }).then(res => {
        this.data.MultiUnitIds = res.Data.map(x => x.UnitId)
      })
      this.getUnit()
      if (this.data.BrandId == 0) {
        this.data.BrandId = null
      }
    },
    getUnit() {
      var index = this.data.MultiUnitIds.findIndex(x => x == this.data.MainUnitId)
      if (index != -1) this.data.MultiUnitIds.splice(index, 1)
      this.unit_api.list({ NoId: this.data.MainUnitId }).then(res => {
        this.MultiUnits = res.Data
      })
    },
    openSupplierDialog() {
      this.$refs.supplierDialog.open().then(that => {
        that.getData()
        that.getTree()
      })
    },
    setSupplier(data) {
      this.data.GoodsSupplierIds = data.map(x => x.TradeUnitId)
      this.data.GoodsSupplierNames = data.map(x => x.TradeUnitName).join('；')
    },
    onBeforeSave() {
      let tableData = this.$refs.dialogList.tableData
      let tableDel = this.$refs.dialogList.tableDel
      let tb = []
      let tableData1 = this.$refs.dialogList1.tableData
      let tableDel1 = this.$refs.dialogList1.tableDel
      let tb1 = []
      if (tableData.length == 0 || !tableData.some(v => v.UnitId)) {
        this.$message.error('请填写单位')
        return false
      }
      if (tableData.every(x => x.IsMain == false)) {
        this.$message.error('必须有一个主单位')
        return false
      }
      for (var i = 0; i < tableData.length; i++) {
        if (tableData[i].UnitId) {
          if (tableData[i].T === 0 || tableData[i].T === 1) {
            tb.push(tableData[i])
          }
        }
      }
      for (var i = 0; i < tableData1.length; i++) {
        if (tableData1[i].T === 0 || tableData1[i].T === 1) {
          tb1.push(tableData1[i])
        }
      }
      //
      this.data.MultiUnits = tb.concat(tableDel)
      this.data.GoodsSuppliers = tb1.concat(tableDel1)
      if (!this.data.MultiUnit) this.data.MultiUnitIds = []
      return true
    },
    onClosed() {
      this.$refs.dialogList.clear()
      this.$refs.dialogList1.clear()
    },
    handleClassChange(value) {
      if (value) {
        // 根据选择的ClassId查找对应的分类名称
        this.findClassName(value);
      } else {
        this.data.ClassName = "";
      }
    },
    findClassName(classId) {
      const findClass = (list, id) => {
        for (let item of list) {
          if (item.ClassId === id) {
            this.data.ClassName = item.ClassName;
            return true;
          }
          if (item.children && item.children.length) {
            if (findClass(item.children, id)) {
              return true;
            }
          }
        }
        return false;
      };
      
      findClass(this.classList, classId);
    }
  }
}
</script>
